import { Component} from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '@app/material.module';
import { AccountComponent } from "@pages/users/user-profile/user-profile/account/account.component";

@Component({
  selector: 'app-user-profile',
    imports: [TablerIconsModule, MaterialModule, AccountComponent],
  templateUrl: './user-profile.component.html',
  standalone: true,
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent {

}
